import {Pipe, PipeTransform} from '@angular/core';
import {TicketsService} from '../../services/tickets.service';

@Pipe({
  name: 'version',
  standalone: true,
})
export class VersionStripPipe implements PipeTransform {

  possibleVersions: Map<string, string>;

  constructor(private ticketService: TicketsService) {
    this.ticketService.getPossibleVersions().subscribe(val => {
      this.possibleVersions = val;
    });
  }

  transform(version: string): string {
    if (version == null || this.possibleVersions === undefined || this.possibleVersions[version] === undefined) {
      return '';
    }
    return this.possibleVersions[version];
  }
}
